import Group from 'components/utils/Group'
import type { ReactElement } from 'react'

interface Props extends Utils.PropsWithDataAttributes {
  startSlot: ReactElement | false
  endSlot: ReactElement | false
  className?: string
}

function _PriceSummaryRow(props: Props) {
  const { startSlot, endSlot, ...rest } = props

  return <Group
    {...rest}
    direction="horizontal"
    horizontalAlign="space-between"
    gap={16}
  >
    {startSlot}
    {endSlot}
  </Group>
}

export default _PriceSummaryRow
